export default __webpack_public_path__ + "static/media/technology_and_equipment_in_UNIFIL.a0a67a00.jpg";